/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Liste } from '@mairistem/liste';

import { URL_SOUS_TYPES_ACTE_MARIAGE } from '@/constants';
import { FiltresListeActes } from '@/components/Common';

import ActeMariageListeTable from './ActeMariageListeTable';

interface ActeMariageListeProps {
  actes?: Array<any>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad?: any;
  onSort?: any;
  /** Réduit la liste à la seule colonne du nom, pour la sidebar de la fiche. */
  sidebar?: boolean;
}

const ActeMariageListe = (props: ActeMariageListeProps) => {
  const {
    actes,
    count,
    perPage,
    loading,
    onLoad,
    onSort,
    sidebar,
    ...handlers
  } = props;

  const tableau = (
    <ActeMariageListeTable
      items={actes}
      loading={loading}
      count={count}
      perPage={perPage}
      onLoad={onLoad}
      onSort={onSort}
      sidebar={sidebar}
    />
  );

  return (
    <Liste
      title="Liste des actes de mariage"
      searchable
      search={{
        clearable: true,
        placeholder:
          "Rechercher par n° d'acte, nom ou prénoms des conjoints ou de leurs parents...",
      }}
      {...handlers}
    >
      <Liste.Content>
        {sidebar ? (
          tableau
        ) : (
          <FiltresListeActes urlSousTypes={URL_SOUS_TYPES_ACTE_MARIAGE}>
            {tableau}
          </FiltresListeActes>
        )}
      </Liste.Content>
    </Liste>
  );
};

export default ActeMariageListe;
